<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >  
                <template v-slot:header >
                  <div class="header-card">
                    Inclusiones de Beneficiarios
                  </div> 
                </template>          
                <b-nav tabs>
                  <b-nav-item :active="active===0" @click="active=0">Incluir beneficiario</b-nav-item>
                  <b-nav-item :active="active===1" @click="active=1;searchInclusiones(1)"  class="d-none d-md-block">Inclusiones Pendientes</b-nav-item>
                  <b-nav-item :active="active===2" @click="active=2;searchInclusiones(2)"  class="d-none d-md-block">Historial de inclusiones</b-nav-item>
                </b-nav> 
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6;">
                  <div v-if="active===0">
                   <validation-observer v-slot="{ invalid } ">   
                    <b-row  align-v="center"> 
                      <sw-searchs
                      :md="5"
                      :lg="5"
                      style="margin-top:20px"
                      label='Seleccionar afiliado'
                      list='datos_afiliado'
                      filterCampos="documento"
                      :filter="{campo: 'id_list_estado', value: 1}"
                      @input="inputSearchs"
                      >
                      </sw-searchs>  
                      <b-col class="d-none">
                        <b-button @click="searchSw.value='';resetDataForm()" style="margin-top:30px" size="sm">Limpiar</b-button>
                      </b-col>
                    </b-row> 
                    <b-row v-if="searchSw.value!=''">                           
                      <sw-inputs
                        inputTabla="afiliado_beneficiarios"
                        inputCampo="id_list_documento" :md="1" :lg="1"></sw-inputs>                  
                      <sw-inputs
                        inputTabla="afiliado_beneficiarios"
                        inputCampo="documento" :md="2" :lg="2"></sw-inputs>                          
                      <sw-inputs
                        inputTabla="afiliado_inclusiones"
                        inputCampo="name"
                        :md="6" :lg="6"></sw-inputs>      
                      <sw-inputs
                        inputTabla="afiliado_beneficiarios"
                        inputCampo="nacimiento"></sw-inputs>                      
                      <sw-inputs
                        inputTabla="afiliado_inclusiones"
                        inputCampo="direccion"></sw-inputs>                  
                      <sw-inputs
                        inputTabla="afiliado_beneficiarios"
                        inputCampo="servicios"  :md="6" :lg="6"></sw-inputs>               
                      <sw-inputs
                        v-if="uploadReady"
                        inputTabla="afiliado_inclusiones"
                        inputCampo="archivo"></sw-inputs>
                    </b-row>
                    <b-row>
                      <b-col class="card-footer  d-none d-md-block"  v-if="searchSw.value!=''">
                       <sw-saveform
                        :invalid="invalid"
                        :index="dataIndex[namePath]"
                        nameBtn="Inclusión"
                        @save="saveForm">
                        </sw-saveform> 

                      </b-col>
                      <b-col class="card-footer d-md-none"  v-if="searchSw.value!=''">
                       <sw-saveform
                        @limpiar="searchSw.value='';resetDataForm()"
                        limpiar
                        :invalid="invalid"
                        :index="dataIndex[namePath]"
                        @save="saveForm">
                        </sw-saveform> 
                      </b-col>
                    </b-row>         
                  </validation-observer>                     
                  </div>
                  <div  v-if="active===1" style="padding:20px">
                    <sw-tableget
                      :filterShow="false"
                      :tableItems="tableGBItems"
                      :tableSearch="tableGBSearch"
                      :tableOptions="tableGBoptions"
                      name="tableGet"
                      @filtrar="getFiltrar2"
                      @save="saveForm"
                      >     
                       <template v-slot:modal>
                        <sw-modalradicarinclusion 
                          v-if="openModal.modal.modal==='Radicado'"
                          @save="saveForm">
                        </sw-modalradicarinclusion>
                         <sw-modalanularinclusion  
                          v-if="openModal.modal.modal==='Eliminar'"
                          @save="saveForm">
                        </sw-modalanularinclusion >
                      </template> 
                    </sw-tableget>
                  </div>
                  <div  v-if="active===2" style="padding:20px">
                    <sw-tableget
                      :tableItems="tableGBHISTItems"
                      :tableSearch="tableGBHISTSearch"
                      name="tableGet2"
                      @filtrar="getFiltrar"
                      @limpiar="getLimpiar"
                      @save="saveForm"
                      >     
                      <template v-slot:filtrar>
                        <b-row  style="margin-bottom:5px;padding-top:15px;border: 1px ridge;background: #fafafa">
                         <b-col :cols="4"> 
                            <b-form-group
                              class="mb-0"
                              label="Seleccionar Afiliado"
                            >                         
                              <c-multiselect
                                style="margin-bottom:15px"   
                                v-model="filter.id_datos_afiliado"                   
                                :options="lists.datos_afiliado"
                                label="name"
                                track-by="name"
                                :clear-on-select="false"
                                :preselect-first="false"
                                :searchable="true"
                                :customLabel="function (value) { return value.documento+' - '+value.name}"
                                :filterCampos="'id|name|documento'"
                                placeholder="Seleccionar"
                                >
                                </c-multiselect>  
                            </b-form-group>                    
                          </b-col>
                        </b-row>                      
                      </template>   
                    </sw-tableget>
                  </div>
                </div>  
            </b-card> 
            <!--<b-card  style="margin-top: 30px"  v-if="dataPost[namePath].data.length>0 && active===0">
                <template v-slot:header >
                  <div class="header-card text-left">
                    Inclusiones Agrupadas
                  </div> 
                </template> 
              <b-row>
                      <b-col>
                        <sw-tablepost
                            :tableOptions="['delete']"
                            :tableItems="[
                              {th: 'Titular', td: ['datos_afiliado/name']},
                              {th: 'Beneficiario', td: ['afiliado_inclusiones/name']},
                              {th: 'Documento', td: ['afiliado_beneficiarios/documento']},
                              {th: 'Dirección', td: ['afiliado_inclusiones/direccion']},
                              {th: 'Nacimiento', td: ['afiliado_inclusiones/nacimiento']},
                            ]"
                            :tableView="['Titular','Beneficiario','Dirección','Archivo']"
                            @save="saveForm"
                            >
                          </sw-tablepost> 
                      </b-col>
                    </b-row>
            </b-card>-->
      </b-col>    
    </b-row>      
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>     
    </b-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwModalradicarinclusion from '@/components/modals/radicarInclusion.vue'
import SwModalanularinclusion from '@/components/modals/anularInclusion.vue'
import SwTablemultiple from '@/components/dataTable/tableMultiple.vue'
import SwTablepost from '@/components/dataTable/tablePost.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import Multiselect  from '@/components/vue-multiselect/src/'
import { ValidationObserver } from 'vee-validate'

export default {
  name: "afiliacion_servicios",
  components: { 
    SwSearchs,
    SwTablemultiple,
    SwSaveform,
    SwModalradicarinclusion,
    SwModalafiliacion,
    SwTablepost,
    SwInputs,
    SwTableget,
    SwModalanularinclusion,
    'c-multiselect': Multiselect,
    ValidationObserver
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
